// Phonetics.jsx
import { useState, useEffect, useRef, useContext } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import api from "../../utils/api";
import "./Phonetics.css";

// --------------------------------------------------------------
// DATA (from original HTML)
// --------------------------------------------------------------
const pronunciationData = [
  {
    word: "schedule",
    ukCorrectAnswer: "/ˈʃɛdjuːl/",
    usCorrectAnswer: "/ˈskɛdʒuːl/",
    incorrectAnswersArray: ["/ˈskɛdʒəl/"],
  },
  // {
  //   word: "tomato",
  //   ukCorrectAnswer: "/təˈmɑːtəʊ/",
  //   usCorrectAnswer: "/təˈmeɪtoʊ/",
  //   incorrectAnswersArray: ["/təˈmætoʊ/"],
  // },
  // {
  //   word: "water",
  //   ukCorrectAnswer: "/ˈwɔːtə/",
  //   usCorrectAnswer: "/ˈwɑːtər/",
  //   incorrectAnswersArray: ["/ˈwɒtər/"],
  // },
  // {
  //   word: "vase",
  //   ukCorrectAnswer: "/vɑːz/",
  //   usCorrectAnswer: "/veɪs/",
  //   incorrectAnswersArray: ["/væz/"],
  // },
  // {
  //   word: "either",
  //   ukCorrectAnswer: "/ˈaɪðə/",
  //   usCorrectAnswer: "/ˈiːðər/",
  //   incorrectAnswersArray: ["/ˈaɪðər/"],
  // },
  // {
  //   word: "route",
  //   ukCorrectAnswer: "/ruːt/",
  //   usCorrectAnswer: "/ruːt/",
  //   incorrectAnswersArray: ["/raʊt/", "/rʊt/"],
  // },
  // {
  //   word: "advertisement",
  //   ukCorrectAnswer: "/ədˈvɜːtɪsmənt/",
  //   usCorrectAnswer: "/ˌædvərˈtaɪzmənt/",
  //   incorrectAnswersArray: ["/ædˈvɜːtɪsmənt/"],
  // },
  // {
  //   word: "privacy",
  //   ukCorrectAnswer: "/ˈprɪvəsi/",
  //   usCorrectAnswer: "/ˈpraɪvəsi/",
  //   incorrectAnswersArray: ["/prɪˈvæsi/"],
  // },
  // {
  //   word: "garage",
  //   ukCorrectAnswer: "/ˈɡærɑːʒ/",
  //   usCorrectAnswer: "/ɡəˈrɑːʒ/",
  //   incorrectAnswersArray: ["/ˈɡærɪdʒ/"],
  // },
  // {
  //   word: "leisure",
  //   ukCorrectAnswer: "/ˈleʒə/",
  //   usCorrectAnswer: "/ˈliːʒər/",
  //   incorrectAnswersArray: ["/ˈlɛʒər/"],
  // },
  // {
  //   word: "herb",
  //   ukCorrectAnswer: "/hɜːb/",
  //   usCorrectAnswer: "/ɜːrb/",
  //   incorrectAnswersArray: ["/hɛrb/"],
  // },
  // {
  //   word: "process",
  //   ukCorrectAnswer: "/ˈprəʊsɛs/",
  //   usCorrectAnswer: "/ˈprɑːsɛs/",
  //   incorrectAnswersArray: ["/ˈproʊsɛs/"],
  // },
  // {
  //   word: "vitamin",
  //   ukCorrectAnswer: "/ˈvɪtəmɪn/",
  //   usCorrectAnswer: "/ˈvaɪtəmɪn/",
  //   incorrectAnswersArray: ["/vɪˈtæmɪn/"],
  // },
  // {
  //   word: "aluminum",
  //   ukCorrectAnswer: "/ˌæljʊˈmɪniəm/",
  //   usCorrectAnswer: "/əˈluːmɪnəm/",
  //   incorrectAnswersArray: ["/ˌæləˈmɪniəm/"],
  // },
  // {
  //   word: "mobile",
  //   ukCorrectAnswer: "/ˈməʊbaɪl/",
  //   usCorrectAnswer: "/ˈmoʊbəl/",
  //   incorrectAnswersArray: ["/ˈmɒbaɪl/"],
  // },
  // {
  //   word: "laboratory",
  //   ukCorrectAnswer: "/ləˈbɒrətri/",
  //   usCorrectAnswer: "/ˈlæbrətɔːri/",
  //   incorrectAnswersArray: ["/ləˈbɔːrətri/"],
  // },
  // {
  //   word: "dance",
  //   ukCorrectAnswer: "/dɑːns/",
  //   usCorrectAnswer: "/dæns/",
  //   incorrectAnswersArray: ["/dɛns/"],
  // },
  // {
  //   word: "neither",
  //   ukCorrectAnswer: "/ˈnaɪðə/",
  //   usCorrectAnswer: "/ˈniːðər/",
  //   incorrectAnswersArray: ["/ˈnaɪðər/"],
  // },
  // {
  //   word: "clerk",
  //   ukCorrectAnswer: "/klɑːk/",
  //   usCorrectAnswer: "/klɜːrk/",
  //   incorrectAnswersArray: ["/klɜːk/"],
  // },
  // {
  //   word: "zebra",
  //   ukCorrectAnswer: "/ˈzɛbrə/",
  //   usCorrectAnswer: "/ˈziːbrə/",
  //   incorrectAnswersArray: ["/ˈzɛbrɑː/"],
  // },
];

const section2Data = [
  {
    word: "chicken",
    uktranscription: "/ˈtʃɪkɪn/",
    ustranscription: "/ˈtʃɪkən/",
    question: ["chicken", "kitchen", "kitten"],
  },
  // {
  //   word: "through",
  //   uktranscription: "/θruː/",
  //   ustranscription: "/θruː/",
  //   question: ["through", "though", "thought"],
  // },
  // {
  //   word: "sugar",
  //   uktranscription: "/ˈʃʊɡə/",
  //   ustranscription: "/ˈʃʊɡər/",
  //   question: ["sugar", "shower", "sure"],
  // },
  // {
  //   word: "accident",
  //   uktranscription: "/ˈæksɪdənt/",
  //   ustranscription: "/ˈæksɪdənt/",
  //   question: ["accident", "incident", "accent"],
  // },
  // {
  //   word: "economy",
  //   uktranscription: "/ɪˈkɒnəmi/",
  //   ustranscription: "/ɪˈkɑːnəmi/",
  //   question: ["economy", "ecology", "economics"],
  // },
  // {
  //   word: "receive",
  //   uktranscription: "/rɪˈsiːv/",
  //   ustranscription: "/rɪˈsiːv/",
  //   question: ["receive", "relieve", "retrieve"],
  // },
  // {
  //   word: "generous",
  //   uktranscription: "/ˈdʒenərəs/",
  //   ustranscription: "/ˈdʒenərəs/",
  //   question: ["generous", "general", "genuine"],
  // },
  // {
  //   word: "experiment",
  //   uktranscription: "/ɪkˈsperɪmənt/",
  //   ustranscription: "/ɪkˈsperɪmənt/",
  //   question: ["experiment", "experience", "expertise"],
  // },
  // {
  //   word: "business",
  //   uktranscription: "/ˈbɪznɪs/",
  //   ustranscription: "/ˈbɪznəs/",
  //   question: ["business", "busyness", "buzzing"],
  // },
  // {
  //   word: "knowledge",
  //   uktranscription: "/ˈnɒlɪdʒ/",
  //   ustranscription: "/ˈnɑːlɪdʒ/",
  //   question: ["knowledge", "college", "acknowledge"],
  // },
  // {
  //   word: "foreign",
  //   uktranscription: "/ˈfɒrɪn/",
  //   ustranscription: "/ˈfɔːrən/",
  //   question: ["foreign", "forest", "orange"],
  // },
  // {
  //   word: "comfortable",
  //   uktranscription: "/ˈkʌmftəbəl/",
  //   ustranscription: "/ˈkʌmfərtəbəl/",
  //   question: ["comfortable", "convertible", "controllable"],
  // },
  // {
  //   word: "accommodate",
  //   uktranscription: "/əˈkɒmədeɪt/",
  //   ustranscription: "/əˈkɑːmədeɪt/",
  //   question: ["accommodate", "accompany", "accomplish"],
  // },
  // {
  //   word: "cinema",
  //   uktranscription: "/ˈsɪnɪmə/",
  //   ustranscription: "/ˈsɪnəmə/",
  //   question: ["cinema", "synonym", "cinnamon"],
  // },
  // {
  //   word: "initial",
  //   uktranscription: "/ɪˈnɪʃəl/",
  //   ustranscription: "/ɪˈnɪʃəl/",
  //   question: ["initial", "essential", "financial"],
  // },
  // {
  //   word: "secret",
  //   uktranscription: "/ˈsiːkrɪt/",
  //   ustranscription: "/ˈsiːkrət/",
  //   question: ["secret", "sacred", "secrete"],
  // },
  // {
  //   word: "education",
  //   uktranscription: "/ˌedjʊˈkeɪʃən/",
  //   ustranscription: "/ˌedʒəˈkeɪʃən/",
  //   question: ["education", "evacuation", "evaluation"],
  // },
  // {
  //   word: "exercise",
  //   uktranscription: "/ˈeksəsaɪz/",
  //   ustranscription: "/ˈeksərsaɪz/",
  //   question: ["exercise", "exorcise", "expertise"],
  // },
  // {
  //   word: "imagine",
  //   uktranscription: "/ɪˈmædʒɪn/",
  //   ustranscription: "/ɪˈmædʒɪn/",
  //   question: ["imagine", "image", "imitate"],
  // },
  // {
  //   word: "office",
  //   uktranscription: "/ˈɒfɪs/",
  //   ustranscription: "/ˈɑːfɪs/",
  //   question: ["office", "official", "off ice"],
  // },
];

const section3Data = [
  { word: "thought", uk: ["/θɔːt/"], us: ["/θɔːt/", "/θoːt/"] },
  // { word: "through", uk: ["/θruː/"], us: ["/θruː/"] },
  // { word: "though", uk: ["/ðəʊ/"], us: ["/ðoʊ/", "/ðou/"] },
  // { word: "cough", uk: ["/kɒf/"], us: ["/kɑːf/", "/kaːf/"] },
  // { word: "plough", uk: ["/plaʊ/"], us: ["/plaʊ/", "/plau/"] },
  // { word: "enough", uk: ["/ɪˈnʌf/"], us: ["/ɪˈnʌf/"] },
  // { word: "yacht", uk: ["/jɒt/"], us: ["/jɑːt/", "/jaːt/"] },
  // { word: "choir", uk: ["/ˈkwaɪə/"], us: ["/ˈkwaɪər/"] },
  {
    word: "hierarchy",
    uk: ["/ˈhaɪərɑːki/"],
    us: [
      "/ˈhaɪərɑːrki/",
      "/ˈhaɪ.rɑːr.ki/",
      "/ˈhaɪrɑːrkɪ/",
      "/ˈhaɪrɑːrki/",
      "/ˈhaɪ,rɑːrkɪ/",
      "/ˈhaɪ,rɑːrki/",
    ],
  },
  // { word: "colonel", uk: ["/ˈkɜːnəl/"], us: ["/ˈkɜːrnəl/"] },
  { word: "Wednesday", uk: ["/ˈwɛnzdeɪ/"], us: ["/ˈwenz.deɪ/", "/ˈwenzdeɪ/"] },
  {
    word: "February",
    uk: ["/ˈfɛbrʊəri/"],
    us: ["/ˈfɛbruːɛri/", "/ˈfebruərɪ/", "/ˈfebrʊərɪ/"],
  },
  // { word: "library", uk: ["/ˈlaɪbrəri/"], us: ["/ˈlaɪbrɛri/", "/ˈlaɪbrərɪ/"] },
  {
    word: "comfortable",
    uk: ["/ˈkʌmftəbəl/"],
    us: [
      "/ˈkʌmfərtəbəl/",
      "/ˈkʌmfərt(ə)bl/",
      "/ˈkʌmfərt(ə)b(ə)l/",
      "/ˈkʌmfərtəb(ə)l/",
    ],
  },
  {
    word: "vegetable",
    uk: ["/ˈvɛdʒtəbəl/"],
    us: [
      "/ˈvɛdʒtəbəl/",
      "/ˈvedʒɪtəbl/",
      "/ˈvedʒ.tə.bəl/",
      "/ˈvedʒtə.bəl/",
      "/ˈvedʒtəb(ə)l/",
      "/ˈvedʒt(ə)b(ə)l/",
    ],
  },
  { word: "chocolate", uk: ["/ˈtʃɒklət/"], us: ["/ˈtʃɑːklət/", "/ˈtʃaːklət/"] },
  // { word: "different", uk: ["/ˈdɪfrənt/"], us: ["/ˈdɪfərənt/", "/ˈdɪfrənt/", "/ˈdɪfr(ə)nt/"] },
  // {
  //   word: "interesting",
  //   uk: ["/ˈɪntrəstɪŋ/"],
  //   us: ["/ˈɪntrəstɪŋ/", "/ˈɪn.trɪ.stɪŋ/"],
  // },
  // {
  //   word: "especially",
  //   uk: ["/ɪˈspeʃəli/"],
  //   us: ["/ɪˈspɛʃəli/", "/ˈɪspeʃəli/"],
  // },
  // {
  //   word: "literally",
  //   uk: ["/ˈlɪtərəli/"],
  //   us: ["/ˈlɪtərəli/", "/ˈlɪtərəli/"],
  // },
];

const section4Data = [
  { word: "bottle", uk: ["/ˈbɒtəl/"], us: ["/ˈbɑːtəl/"] },
  // { word: "cabin", uk: ["/ˈkæbɪn/"], us: ["/ˈkæbɪn/"] },
  // { word: "telephone", uk: ["/ˈtelɪfəʊn/"], us: ["/ˈtɛlɪfoʊn/"] },
  // { word: "confidence", uk: ["/ˈkɒnfɪdəns/"], us: ["/ˈkɑːnfɪdəns/"] },
  // { word: "develop", uk: ["/dɪˈveləp/"], us: ["/dɪˈvɛləp/"] },
  // { word: "education", uk: ["/ˌedjʊˈkeɪʃən/"], us: ["/ˌɛdʒəˈkeɪʃən/"] },
  // { word: "memory", uk: ["/ˈmeməri/"], us: ["/ˈmɛməri/"] },
  // { word: "purpose", uk: ["/ˈpɜːpəs/"], us: ["/ˈpɜːrpəs/"] },
  // { word: "circle", uk: ["/ˈsɜːkəl/"], us: ["/ˈsɜːrkəl/"] },
  // { word: "among", uk: ["/əˈmʌŋ/"], us: ["/əˈmʌŋ/"] },
  // { word: "basis", uk: ["/ˈbeɪsɪs/"], us: ["/ˈbeɪsɪs/"] },
  // { word: "calendar", uk: ["/ˈkælɪndə/"], us: ["/ˈkælɪndər/"] },
  // { word: "definite", uk: ["/ˈdefɪnɪt/"], us: ["/ˈdɛfɪnɪt/"] },
  // { word: "explain", uk: ["/ɪkˈspleɪn/"], us: ["/ɪkˈspleɪn/"] },
  // { word: "forward", uk: ["/ˈfɔːwəd/"], us: ["/ˈfɔːrwərd/"] },
  // { word: "guarantee", uk: ["/ˌɡærənˈtiː/"], us: ["/ˌɡærənˈtiː/"] },
  // { word: "hospital", uk: ["/ˈhɒspɪtəl/"], us: ["/ˈhɑːspɪtəl/"] },
  // { word: "immediate", uk: ["/ɪˈmiːdiət/"], us: ["/ɪˈmiːdiət/"] },
  // { word: "general", uk: ["/ˈdʒenərəl/"], us: ["/ˈdʒɛnərəl/"] },
  // { word: "knowledge", uk: ["/ˈnɒlɪdʒ/"], us: ["/ˈnɑːlɪdʒ/"] },
];

const section5Data = [
  { word: "ice cream", uk: ["/ˈaɪs kriːm/"], us: ["/ˈaɪs kriːm/"] },
  // { word: "high school", uk: ["/ˈhaɪ skuːl/"], us: ["/ˈhaɪ skuːl/"] },
  // { word: "businessman", uk: ["/ˈbɪznɪs mæn/"], us: ["/ˈbɪznɪs mæn/"] },
  // { word: "parking lot", uk: ["/ˈpɑːkɪŋ lɒt/"], us: ["/ˈpɑːrkɪŋ lɑːt/"] },
  // { word: "fast food", uk: ["/ˈfɑːst fuːd/"], us: ["/ˈfæst fuːd/"] },
  // { word: "rainy day", uk: ["/ˈreɪni deɪ/"], us: ["/ˈreɪni deɪ/"] },
  // { word: "mother tongue", uk: ["/ˈmʌðə tʌŋ/"], us: ["/ˈmʌðər tʌŋ/"] },
  // { word: "traffic jam", uk: ["/ˈtræfɪk dʒæm/"], us: ["/ˈtræfɪk dʒæm/"] },
  // { word: "running shoes", uk: ["/ˈrʌnɪŋ ʃuːz/"], us: ["/ˈrʌnɪŋ ʃuːz/"] },
  // { word: "world peace", uk: ["/ˈwɜːld piːs/"], us: ["/ˈwɜːrld piːs/"] },
];

const section6Data = [
  {
    word: "Make him an offer he can't refuse.",
    uk: ["/ˈmeɪk hɪm ən ˈɒfə hi ˈkɑːnt rɪˈfjuːz/"],
    us: ["/ˈmeɪk hɪm ən ˈɑːfər hi ˈkænt rɪˈfjuːz/"],
    author: "The Godfather",
  },
  {
    word: "To be or not to be, that is the question.",
    uk: ["/ˈtuː biː ər ˈnɒt tuː biː ðæt ɪz ðə ˈkwɛstʃən/"],
    us: ["/ˈtuː biː ər ˈnɑːt tuː biː ðæt ɪz ðə ˈkwɛstʃən/"],
    author: "Hamlet",
  },
  // {
  //   word: "She sells seashells by the seashore.",
  //   uk: ["/ʃiː sɛlz ˈsiː ʃɛlz baɪ ðə ˈsiː ʃɔː/"],
  //   us: ["/ʃi sɛlz ˈsiː ʃɛlz baɪ ðə ˈsiː ʃɔːr/"],
  //   author: "tongue twister",
  // },
  // {
  //   word: "How much wood would a woodchuck chuck if a woodchuck could chuck wood?",
  //   uk: ["/haʊ mʌtʃ wʊd ə ˈwʊdʧʌk ʧʌk ɪf ə ˈwʊdʧʌk kʊd ʧʌk wʊd/"],
  //   us: ["/haʊ mʌtʃ ˈwʊd wʊd ə ˈwʊdʧʌk ˈʧʌk ɪf ə ˈwʊdʧʌk kʊd ˈʧʌk wʊd/"],
  //   author: "tongue twister",
  // },
  // {
  //   word: "I'll be back.",
  //   uk: ["/aɪl bi ˈbæk/"],
  //   us: ["/ˈaɪl bi ˈbæk/"],
  //   author: "Terminator",
  // },
  // {
  //   word: "You can't handle the truth!",
  //   uk: ["/ˈjuː kɑːnt ˈhændl ðə truːθ/"],
  //   us: ["/ˈjuː kɑːnt ˈhændl ðə truːθ/"],
  //   author: "A Few Good Men",
  // },
  // {
  //   word: "May the Force be with you.",
  //   uk: ["/ˈmeɪ ðə fɔːs bi wɪð juː/"],
  //   us: ["/ˈmeɪ ðə fɔːs bi wɪð juː/"],
  //   author: "Star Wars",
  // },
  // {
  //   word: "The quick brown fox jumps over the lazy dog.",
  //   uk: ["/ðə kwɪk braʊn fɒks ˈdʒʌmps ˈəʊvə ðə ˈleɪzi dɒɡ/"],
  //   us: ["/ðə ˈkwɪk braʊn fɑːks ˈdʒʌmps ˈoʊvər ðə ˈleɪzi dɔːɡ/"],
  //   author: "pangram",
  // },
  // {
  //   word: "I see dead people.",
  //   uk: ["/aɪ siː ˈdiːd ˈpiːpəl/"],
  //   us: ["/ˈaɪ siː ˈdɛd ˈpiːpəl/"],
  //   author: "The Sixth Sense",
  // },
  // {
  //   word: "Frankly, my dear, I don't give a damn.",
  //   uk: ["/ˈfræŋkli maɪ dɪə aɪ dəʊnt ɡɪv ə ˈdæm/"],
  //   us: ["/ˈfɹæŋkli maɪ ˈdɪə aɪ dəʊnt ɡɪv ə ˈdæm/"],
  //   author: "Gone with the Wind",
  // },
];

// Helper functions
const shuffleArray = (arr) => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

const normalize = (s) => {
  if (!s || typeof s !== "string") return "";
  return String(s)
    .trim()
    .toLowerCase()
    .replace(/:/g, " ") // Replace colons with space
    .replace(/-/g, " ") // Replace hyphens with space
    .replace(/[^\w\s']/g, "") // Remove other special characters (keep letters, numbers, spaces, apostrophes)
    .replace(/\s+/g, " ") // Normalize multiple spaces to single space
    .trim();
};

const normalizeIpa = (s) => {
  if (!s || typeof s !== "string") return "";
  return s
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .replace(/[ˈˌ]/g, "")
    .replace(/:/g, "ː")
    .replace(/\s/g, "")
    .toLowerCase();
};

const isIpaCorrect = (user, correctList) => {
  if (!user || typeof user !== "string") return false;
  return correctList.some((c) => normalizeIpa(user) === normalizeIpa(c));
};

const isTextCorrect = (user, correct, extra = []) => {
  if (!user || typeof user !== "string") return false;
  let norm = normalize(user);
  console.log("Normalized user answer: " + norm);
  console.log("Normalized correct answer answer: " + normalize(correct));
  if (norm === normalize(correct)) return true;
  return extra.some((e) => norm === normalize(e));
};

const Phonetics = ({ isDark }) => {
  const currentUser = useContext(CurrentUserContext);
  const [testLocked, setTestLocked] = useState(false);
  const [userAnswers, setUserAnswers] = useState({});
  const [currentVariant, setCurrentVariant] = useState("uk");
  const [section1Opts, setSection1Opts] = useState([]);
  const [section2Opts, setSection2Opts] = useState([]);
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [testResults, setTestResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const activeInputRef = useRef(null);
  const keyboardRef = useRef(null);
  const saveTimeoutRef = useRef(null);
  const isMountedRef = useRef(true);

  const [testHistory, setTestHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [bestScore, setBestScore] = useState(null);

  // Load test history
  const loadTestHistory = async () => {
    if (!currentUser || !currentUser._id) return;

    try {
      const response = await api.getPhoneticTestHistory();
      setTestHistory(response.data.attempts || []);
      setBestScore(response.data.bestAttempt);
    } catch (error) {
      console.error("Failed to load test history:", error);
    }
  };

  // Load history when component mounts and after submission
  useEffect(() => {
    if (currentUser && currentUser._id) {
      loadTestHistory();
    }
  }, [currentUser]);

  // Calculate total questions
  const totalQuestions =
    pronunciationData.length +
    section2Data.length +
    section3Data.length +
    section4Data.length +
    section5Data.length +
    section6Data.length;

  // IPA symbols
  const ipaSymbols = [
    "æ",
    "ɑː",
    "ʌ",
    "ɒ",
    "ɔː",
    "ə",
    "ɜː",
    "e",
    "iː",
    "ɪ",
    "uː",
    "ʊ",
    "aɪ",
    "aʊ",
    "eə",
    "eɪ",
    "ɪə",
    "oʊ",
    "ɔɪ",
    "ʊə",
    "p",
    "b",
    "t",
    "d",
    "k",
    "g",
    "m",
    "n",
    "ŋ",
    "f",
    "v",
    "θ",
    "ð",
    "s",
    "z",
    "ʃ",
    "ʒ",
    "h",
    "l",
    "r",
    "w",
    "j",
    "tʃ",
    "dʒ",
    "tr",
    "dr",
    "ts",
    "dz",
    "ˈ",
    "ˌ",
    "ː",
  ];

  // Load user data from server
  useEffect(() => {
    const loadUserTestData = async () => {
      if (!currentUser || !currentUser._id) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const response = await api.getPhoneticTestResult();

        if (!isMountedRef.current) return;

        const data = response.data;
        setUserAnswers(data.answers || {});
        setTestLocked(data.submitted || false);
        setCurrentVariant(data.variant || "uk");

        // For submitted tests, recalculate the results from stored answers
        if (data.submitted && data.answers) {
          const { total, resultItems } = calculateTestResults(
            data.answers,
            data.variant,
          );
          setTestResults({ total, resultItems });
        }
      } catch (error) {
        console.error("Failed to load test data:", error);
        if (isMountedRef.current) {
          setUserAnswers({});
          setTestLocked(false);
          setCurrentVariant("uk");
        }
      } finally {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }
    };

    loadUserTestData();

    return () => {
      isMountedRef.current = false;
    };
  }, [currentUser]);

  // Calculate test results based on answers and variant
  const calculateTestResults = (answers, variant) => {
    let total = 0;
    const resultItems = {};

    // Раздел 1 - compare actual values, not letters
    pronunciationData.forEach((item, idx) => {
      let qid = `s1_${idx}`;
      let userAnswer = answers[qid];
      let correctAnswer =
        variant === "uk" ? item.ukCorrectAnswer : item.usCorrectAnswer;
      let isCorrect = userAnswer === correctAnswer;
      if (isCorrect) total++;
      resultItems[qid] = {
        isCorrect,
        userAnswer: userAnswer || "(не выбран)",
        correctAnswer: correctAnswer,
        feedback: `Правильный ответ: ${correctAnswer}`,
      };
    });

    // Раздел 2 - compare actual word values
    section2Data.forEach((item, idx) => {
      let qid = `s2_${idx}`;
      let userAnswer = answers[qid];
      let isCorrect = userAnswer === item.word;
      if (isCorrect) total++;
      resultItems[qid] = {
        isCorrect,
        userAnswer: userAnswer || "(не выбран)",
        correctAnswer: item.word,
        feedback: `Правильный ответ: ${item.word}`,
      };
    });

    // Раздел 3
    section3Data.forEach((item, idx) => {
      let qid = `s3_${idx}`;
      let userAnswer = answers[qid] || "";
      let correctList = variant === "uk" ? item.uk : item.us;
      let isCorrect = isIpaCorrect(userAnswer, correctList);
      if (isCorrect) total++;
      resultItems[qid] = {
        isCorrect,
        userAnswer: userAnswer || "(не введено)",
        correctAnswer: correctList.join(" или "),
        feedback: `Правильный вариант: ${correctList.join(" или ")}`,
      };
    });

    // Раздел 4
    section4Data.forEach((item, idx) => {
      let qid = `s4_${idx}`;
      let userAnswer = answers[qid] || "";
      let isCorrect = isTextCorrect(userAnswer, item.word);
      if (isCorrect) total++;
      resultItems[qid] = {
        isCorrect,
        userAnswer: userAnswer || "(не введено)",
        correctAnswer: item.word,
        feedback: `Правильное слово: ${item.word}`,
      };
    });

    // Раздел 5
    section5Data.forEach((item, idx) => {
      let qid = `s5_${idx}`;
      let userAnswer = answers[qid] || "";
      let isCorrect = isTextCorrect(userAnswer, item.word);
      if (isCorrect) total++;
      resultItems[qid] = {
        isCorrect,
        userAnswer: userAnswer || "(не введено)",
        correctAnswer: item.word,
        feedback: `Правильно: ${item.word}`,
      };
    });

    // Раздел 6
    section6Data.forEach((item, idx) => {
      let qid = `s6_${idx}`;
      let userAnswer = answers[qid] || "";
      let isCorrect = isTextCorrect(userAnswer, item.word);
      if (isCorrect) total++;
      resultItems[qid] = {
        isCorrect,
        userAnswer: userAnswer || "(не введено)",
        correctAnswer: item.word,
        feedback: `Правильно: ${item.word} (${item.author})`,
      };
    });

    return { total, resultItems };
  };

  // Auto-save answers with debounce
  useEffect(() => {
    if (!currentUser || !currentUser._id || testLocked) return;

    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }

    saveTimeoutRef.current = setTimeout(async () => {
      if (Object.keys(userAnswers).length > 0 && isMountedRef.current) {
        setSaving(true);
        try {
          await api.savePhoneticTestAnswers(userAnswers, currentVariant);
        } catch (error) {
          console.error("Failed to auto-save:", error);
        } finally {
          if (isMountedRef.current) {
            setSaving(false);
          }
        }
      }
    }, 1000);
  }, [userAnswers, currentVariant, currentUser, testLocked]);

  // Save on unmount
  useEffect(() => {
    return () => {
      if (saveTimeoutRef.current) {
        clearTimeout(saveTimeoutRef.current);
      }
      if (
        currentUser &&
        currentUser._id &&
        !testLocked &&
        Object.keys(userAnswers).length > 0
      ) {
        api
          .savePhoneticTestAnswers(userAnswers, currentVariant)
          .catch(console.error);
      }
    };
  }, []);

  // Initialize options when variant changes
  useEffect(() => {
    const buildSection1Options = (variant) => {
      return pronunciationData.map((item) => {
        const ukAnswer = item.ukCorrectAnswer;
        const usAnswer = item.usCorrectAnswer;
        const incorrectAnswer = item.incorrectAnswersArray[0];
        let options = [ukAnswer, usAnswer, incorrectAnswer];
        options = shuffleArray([...options]);
        const correctAnswer = variant === "uk" ? ukAnswer : usAnswer;
        return { options, correctAnswer };
      });
    };

    const buildSection2Options = (variant) => {
      return section2Data.map((item) => {
        const options = shuffleArray([...item.question]);
        const correctAnswer = item.word;
        return { options, correctAnswer };
      });
    };

    setSection1Opts(buildSection1Options(currentVariant));
    setSection2Opts(buildSection2Options(currentVariant));
  }, [currentVariant]);

  const switchVariant = async (variant) => {
    if (testLocked) {
      alert("Нельзя сменить вариант после сдачи теста.");
      return;
    }
    if (currentVariant === variant) return;

    setCurrentVariant(variant);
    setUserAnswers({});
    setTestLocked(false);
    setTestResults(null);

    if (currentUser && currentUser._id) {
      try {
        await api.savePhoneticTestAnswers({}, variant);
      } catch (error) {
        console.error("Failed to save variant change:", error);
      }
    }
  };

  // New data structure for saving test state
  const saveTestState = async () => {
    const testState = {
      variant: currentVariant,
      answers: userAnswers,
      questions: {
        section1: pronunciationData.map((item, idx) => ({
          id: `s1_${idx}`,
          word: item.word,
          correctAnswer:
            currentVariant === "uk"
              ? item.ukCorrectAnswer
              : item.usCorrectAnswer,
          options: section1Opts[idx]?.options || [],
          type: "multiple-choice",
        })),
        section2: section2Data.map((item, idx) => ({
          id: `s2_${idx}`,
          transcription:
            currentVariant === "uk"
              ? item.uktranscription
              : item.ustranscription,
          correctAnswer: item.word,
          options: section2Opts[idx]?.options || [],
          type: "multiple-choice",
        })),
        section3: section3Data.map((item, idx) => ({
          id: `s3_${idx}`,
          word: item.word,
          correctAnswer: currentVariant === "uk" ? item.uk[0] : item.us[0],
          possibleAnswers: currentVariant === "uk" ? item.uk : item.us,
          type: "ipa-input",
        })),
        section4: section4Data.map((item, idx) => ({
          id: `s4_${idx}`,
          transcription: currentVariant === "uk" ? item.uk[0] : item.us[0],
          correctAnswer: item.word,
          type: "text-input",
        })),
        section5: section5Data.map((item, idx) => ({
          id: `s5_${idx}`,
          transcription: currentVariant === "uk" ? item.uk[0] : item.us[0],
          correctAnswer: item.word,
          type: "text-input",
        })),
        section6: section6Data.map((item, idx) => ({
          id: `s6_${idx}`,
          transcription: currentVariant === "uk" ? item.uk[0] : item.us[0],
          correctAnswer: item.word,
          author: item.author,
          type: "text-input",
        })),
      },
    };

    return testState;
  };

  const handleInputChange = (qid, value) => {
    setUserAnswers((prev) => ({ ...prev, [qid]: value }));
  };

  const handleRadioChange = (qid, value) => {
    setUserAnswers((prev) => ({ ...prev, [qid]: value }));
  };

  // Add resetTest function
  const resetTest = async () => {
    if (
      window.confirm(
        "Вы уверены, что хотите сбросить тест? Весь прогресс будет потерян, и вы сможете пройти тест заново.",
      )
    ) {
      setLoading(true);
      try {
        await api.resetPhoneticTest();
        // Reset all local state
        setUserAnswers({});
        setTestLocked(false);
        setTestResults(null);
        setCurrentVariant("uk");
        // Reload fresh data
        const response = await api.getPhoneticTestResult();
        const data = response.data;
        setUserAnswers(data.answers || {});
        setTestLocked(data.submitted || false);
        setCurrentVariant(data.variant || "uk");
        alert("Тест успешно сброшен. Вы можете пройти его заново.");
      } catch (error) {
        console.error("Failed to reset test:", error);
        alert("Ошибка при сбросе теста. Пожалуйста, попробуйте снова.");
      } finally {
        setLoading(false);
      }
    }
  };

  // Update resetAnswers to also call server reset
  const resetAnswers = () => {
    if (window.confirm("Сбросить ответы? Весь прогресс будет потерян.")) {
      setUserAnswers({});
      setTestLocked(false);
      setTestResults(null);
      if (currentUser && currentUser._id) {
        api.savePhoneticTestAnswers({}, currentVariant).catch(console.error);
      }
    }
  };

  // Updated submitTest function
  const submitTest = async () => {
    if (testLocked) {
      alert("Тест уже сдан");
      return;
    }

    const { total, resultItems } = calculateTestResults(
      userAnswers,
      currentVariant,
    );
    const testState = await saveTestState();

    setTestLocked(true);
    setTestResults({ total, resultItems });

    if (currentUser && currentUser._id) {
      try {
        await api.submitPhoneticTest(
          userAnswers,
          currentVariant,
          total,
          totalQuestions,
          testState.questions, // Pass the questions with correct answers
        );
        await loadTestHistory();
        alert(`Тест завершен! Ваш результат: ${total} из ${totalQuestions}`);
      } catch (error) {
        console.error("Failed to submit test:", error);
        alert(
          "Ошибка при сохранении результатов. Пожалуйста, попробуйте снова.",
        );
        setTestLocked(false);
        return;
      }
    }
  };

  const handleIpaFocus = (e) => {
    activeInputRef.current = e.target;
    setShowKeyboard(true);
  };

  const insertIpaSymbol = (symbol) => {
    if (activeInputRef.current) {
      const input = activeInputRef.current;
      const s = input.selectionStart;
      const e = input.selectionEnd;
      const val = input.value;
      const newValue = val.slice(0, s) + symbol + val.slice(e);
      input.value = newValue;
      input.setSelectionRange(s + symbol.length, s + symbol.length);
      input.focus();
      const qid = input.dataset.qid;
      if (qid) {
        handleInputChange(qid, newValue);
      }
    } else {
      alert("Кликните в поле ввода транскрипции");
    }
  };

  const hideKeyboard = () => {
    setShowKeyboard(false);
    activeInputRef.current = null;
  };

  const isQuestionCorrect = (qid) => {
    return testResults?.resultItems[qid]?.isCorrect;
  };

  const getQuestionFeedback = (qid) => {
    return testResults?.resultItems[qid]?.feedback;
  };

  const getUserAnswer = (qid) => {
    return testResults?.resultItems[qid]?.userAnswer;
  };

  const getCorrectAnswer = (qid) => {
    return testResults?.resultItems[qid]?.correctAnswer;
  };

  const renderTest = () => {
    return (
      <div className={`phonetics-container ${isDark ? "dark" : ""}`}>
        <div className='user-bar'>
          <div>
            <strong>👤 Student:</strong> {currentUser?.fullName || "Guest"}
          </div>
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            {saving && (
              <span
                className='saving-indicator'
                style={{ fontSize: "12px", color: "#666" }}
              >
                Сохранение...
              </span>
            )}
            <div className='variant-switch'>
              <div
                className={`variant-btn ${currentVariant === "uk" ? "active" : ""}`}
                onClick={() => switchVariant("uk")}
              >
                🇬🇧 UK
              </div>
              <div
                className={`variant-btn ${currentVariant === "us" ? "active" : ""}`}
                onClick={() => switchVariant("us")}
              >
                🇺🇸 US
              </div>
            </div>
          </div>
        </div>
        {testResults && (
          <div className='score-board'>
            🎯 You scored {testResults.total} out of {totalQuestions} points (
            {currentVariant.toUpperCase()}).{" "}
            {testResults.total >= 70 ? "Good job!" : "Try again."}
          </div>
        )}
        <div id='questionsContainer'>
          {/* Раздел 1 */}
          <div className='section'>
            <h2>
              📌 Раздел 1 ({pronunciationData.length} слов) — выберите
              транскрипцию ({currentVariant.toUpperCase()})
            </h2>
            {pronunciationData.map((item, idx) => {
              let qid = `s1_${idx}`;
              let saved = userAnswers[qid] || "";
              let opts = section1Opts[idx]?.options || [];
              const isCorrect = isQuestionCorrect(qid);
              const feedback = getQuestionFeedback(qid);
              const userAnswer = getUserAnswer(qid);
              const correctAnswer = getCorrectAnswer(qid);

              return (
                <div
                  className={`question-item ${testResults && (isCorrect ? "correct-highlight" : "wrong-highlight")}`}
                  key={qid}
                >
                  <div className='question-text'>
                    {idx + 1}. {item.word}
                  </div>
                  <div className='mc-options'>
                    {opts.map((opt, optIdx) => {
                      return (
                        <label key={optIdx}>
                          <input
                            type='radio'
                            name={qid}
                            value={opt}
                            disabled={testLocked}
                            checked={saved === opt}
                            onChange={(e) =>
                              handleRadioChange(qid, e.target.value)
                            }
                          />{" "}
                          {opt}
                        </label>
                      );
                    })}
                  </div>
                  {testResults && feedback && (
                    <div className='mark-feedback'>
                      {isCorrect ? (
                        <span className='correct-mark'>✅ Верно</span>
                      ) : (
                        <>
                          <span className='wrong-mark'>❌ Неверно</span>
                          <div className='feedback-details'>
                            <span className='feedback-wrong'>{feedback}</span>
                            <span className='user-answer'>
                              Ваш ответ: {userAnswer}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Раздел 2 */}
          <div className='section'>
            <h2>
              📌 Раздел 2 ({section2Data.length} пунктов) — выберите слово
            </h2>
            {section2Data.map((item, idx) => {
              let qid = `s2_${idx}`;
              let saved = userAnswers[qid] || "";
              let transcription =
                currentVariant === "uk"
                  ? item.uktranscription
                  : item.ustranscription;
              let opts = section2Opts[idx]?.options || [];
              const isCorrect = isQuestionCorrect(qid);
              const feedback = getQuestionFeedback(qid);
              const userAnswer = getUserAnswer(qid);
              const correctAnswer = getCorrectAnswer(qid);

              return (
                <div
                  className={`question-item ${testResults && (isCorrect ? "correct-highlight" : "wrong-highlight")}`}
                  key={qid}
                >
                  <div className='question-text'>
                    {idx + 1 + pronunciationData.length}. Транскрипция:{" "}
                    <strong>{transcription}</strong>
                  </div>
                  <div className='mc-options'>
                    {opts.map((opt, optIdx) => {
                      return (
                        <label key={optIdx}>
                          <input
                            type='radio'
                            name={qid}
                            value={opt}
                            disabled={testLocked}
                            checked={saved === opt}
                            onChange={(e) =>
                              handleRadioChange(qid, e.target.value)
                            }
                          />{" "}
                          {opt}
                        </label>
                      );
                    })}
                  </div>
                  {testResults && feedback && (
                    <div className='mark-feedback'>
                      {isCorrect ? (
                        <span className='correct-mark'>✅ Верно</span>
                      ) : (
                        <>
                          <span className='wrong-mark'>❌ Неверно</span>
                          <div className='feedback-details'>
                            <span className='feedback-wrong'>{feedback}</span>
                            <span className='user-answer'>
                              Ваш ответ: {userAnswer}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Раздел 3 */}
          <div className='section'>
            <div className='section-header'>
              <h2>
                📌 Раздел 3 ({section3Data.length} слов) — напишите транскрипцию
                (IPA)
              </h2>
              <button
                type='button'
                className='ipa-toggle-btn'
                onClick={() => setShowKeyboard(true)}
              >
                ⌨️ Показать клавиатуру
              </button>
            </div>
            {section3Data.map((item, idx) => {
              let qid = `s3_${idx}`;
              let saved = userAnswers[qid] || "";
              const isCorrect = isQuestionCorrect(qid);
              const feedback = getQuestionFeedback(qid);
              const userAnswer = getUserAnswer(qid);
              const correctAnswer = getCorrectAnswer(qid);
              const offset = pronunciationData.length + section2Data.length;

              return (
                <div
                  className={`question-item ${testResults && (isCorrect ? "correct-highlight" : "wrong-highlight")}`}
                  key={qid}
                >
                  <div className='question-text'>
                    {idx + 1 + offset}. Слово: <strong>{item.word}</strong>
                  </div>
                  <input
                    type='text'
                    className='ipa-input'
                    placeholder='Введите транскрипцию'
                    value={saved || ""}
                    disabled={testLocked}
                    data-qid={qid}
                    onFocus={handleIpaFocus}
                    inputMode='none'
                    onChange={(e) => handleInputChange(qid, e.target.value)}
                  />
                  {testResults && feedback && (
                    <div className='mark-feedback'>
                      {isCorrect ? (
                        <span className='correct-mark'>✅ Верно</span>
                      ) : (
                        <>
                          <span className='wrong-mark'>❌ Неверно</span>
                          <div className='feedback-details'>
                            <span className='feedback-wrong'>{feedback}</span>
                            <span className='user-answer'>
                              Ваш ответ: {userAnswer}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Раздел 4 */}
          <div className='section'>
            <h2>
              📌 Раздел 4 ({section4Data.length} слов) — напишите слово по
              транскрипции
            </h2>
            {section4Data.map((item, idx) => {
              let qid = `s4_${idx}`;
              let saved = userAnswers[qid] || "";
              let transcription =
                currentVariant === "uk" ? item.uk[0] : item.us[0];
              const isCorrect = isQuestionCorrect(qid);
              const feedback = getQuestionFeedback(qid);
              const userAnswer = getUserAnswer(qid);
              const correctAnswer = getCorrectAnswer(qid);
              const offset =
                pronunciationData.length +
                section2Data.length +
                section3Data.length;

              return (
                <div
                  className={`question-item ${testResults && (isCorrect ? "correct-highlight" : "wrong-highlight")}`}
                  key={qid}
                >
                  <div className='question-text'>
                    {idx + 1 + offset}. Транскрипция:{" "}
                    <strong>{transcription}</strong>
                  </div>
                  <input
                    type='text'
                    placeholder='Введите слово'
                    value={saved || ""}
                    disabled={testLocked}
                    data-qid={qid}
                    onChange={(e) => handleInputChange(qid, e.target.value)}
                  />
                  {testResults && feedback && (
                    <div className='mark-feedback'>
                      {isCorrect ? (
                        <span className='correct-mark'>✅ Верно</span>
                      ) : (
                        <>
                          <span className='wrong-mark'>❌ Неверно</span>
                          <div className='feedback-details'>
                            <span className='feedback-wrong'>{feedback}</span>
                            <span className='user-answer'>
                              Ваш ответ: {userAnswer}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Раздел 5 */}
          <div className='section'>
            <h2>📌 Раздел 5 ({section5Data.length} словосочетаний)</h2>
            {section5Data.map((item, idx) => {
              let qid = `s5_${idx}`;
              let saved = userAnswers[qid] || "";
              let transcription =
                currentVariant === "uk" ? item.uk[0] : item.us[0];
              const isCorrect = isQuestionCorrect(qid);
              const feedback = getQuestionFeedback(qid);
              const userAnswer = getUserAnswer(qid);
              const correctAnswer = getCorrectAnswer(qid);
              const offset =
                pronunciationData.length +
                section2Data.length +
                section3Data.length +
                section4Data.length;

              return (
                <div
                  className={`question-item ${testResults && (isCorrect ? "correct-highlight" : "wrong-highlight")}`}
                  key={qid}
                >
                  <div className='question-text'>
                    {idx + 1 + offset}. Транскрипция:{" "}
                    <strong>{transcription}</strong>
                  </div>
                  <input
                    type='text'
                    placeholder='Словосочетание'
                    value={saved || ""}
                    disabled={testLocked}
                    data-qid={qid}
                    onChange={(e) => handleInputChange(qid, e.target.value)}
                  />
                  {testResults && feedback && (
                    <div className='mark-feedback'>
                      {isCorrect ? (
                        <span className='correct-mark'>✅ Верно</span>
                      ) : (
                        <>
                          <span className='wrong-mark'>❌ Неверно</span>
                          <div className='feedback-details'>
                            <span className='feedback-wrong'>{feedback}</span>
                            <span className='user-answer'>
                              Ваш ответ: {userAnswer}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Раздел 6 */}
          <div className='section'>
            <h2>📌 Раздел 6 ({section6Data.length} предложений)</h2>
            {section6Data.map((item, idx) => {
              let qid = `s6_${idx}`;
              let saved = userAnswers[qid] || "";
              let transcription =
                currentVariant === "uk" ? item.uk[0] : item.us[0];
              const isCorrect = isQuestionCorrect(qid);
              const feedback = getQuestionFeedback(qid);
              const userAnswer = getUserAnswer(qid);
              const correctAnswer = getCorrectAnswer(qid);
              const offset =
                pronunciationData.length +
                section2Data.length +
                section3Data.length +
                section4Data.length +
                section5Data.length;

              return (
                <div
                  className={`question-item ${testResults && (isCorrect ? "correct-highlight" : "wrong-highlight")}`}
                  key={qid}
                >
                  <div className='question-text'>
                    {idx + 1 + offset}. Транскрипция:{" "}
                    <strong>{transcription}</strong>
                    <br />
                    <span className='subnote'>(автор: {item.author})</span>
                  </div>
                  <textarea
                    placeholder='Напишите предложение'
                    value={saved || ""}
                    disabled={testLocked}
                    data-qid={qid}
                    onChange={(e) => handleInputChange(qid, e.target.value)}
                    rows={2}
                    // style={{
                    //   width: "100%",
                    //   padding: "8px",
                    //   borderRadius: "4px",
                    //   border: "1px solid #ddd",
                    // }}
                  />
                  {testResults && feedback && (
                    <div className='mark-feedback'>
                      {isCorrect ? (
                        <span className='correct-mark'>✅ Верно</span>
                      ) : (
                        <>
                          <span className='wrong-mark'>❌ Неверно</span>
                          <div className='feedback-details'>
                            <span className='feedback-wrong'>{feedback}</span>
                            <span className='user-answer'>
                              Ваш ответ: {userAnswer}
                            </span>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {/* // Add retake button in the UI when test is completed */}
        {testLocked && (
          <div
            className='retake-section'
            style={{ marginTop: "20px", textAlign: "center" }}
          >
            <button
              id='retakeTestBtn'
              onClick={resetTest}
              style={{
                backgroundColor: "#f0ad4e",
                color: "white",
                border: "none",
                padding: "12px 24px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "16px",
                marginRight: "10px",
              }}
            >
              🔄 Пройти тест заново
            </button>
            <button
              id='resetAnswersBtn'
              className='btn-small'
              onClick={resetAnswers}
              style={{
                backgroundColor: "#d9534f",
                color: "white",
                border: "none",
                padding: "12px 24px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              🗑️ Сбросить ответы
            </button>
          </div>
        )}
        {!testLocked && (
          <>
            <button id='submitTestBtn' onClick={submitTest}>
              ✅ Завершить тест и проверить
            </button>
            <button
              id='resetAnswersBtn'
              className='btn-small'
              onClick={resetAnswers}
            >
              🗑️ Сбросить ответы
            </button>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      {renderTest()}
      {showKeyboard && (
        <div className='ipa-keyboard' ref={keyboardRef}>
          {ipaSymbols.map((sym, idx) => (
            <button key={idx} onClick={() => insertIpaSymbol(sym)}>
              {sym}
            </button>
          ))}

          <button className='close-ipa' onClick={hideKeyboard}>
            ✖ Закрыть
          </button>
        </div>
      )}
    </>
  );
};

export default Phonetics;
